<template>
    <transition name="slide-fade" >
        <div >
            <div class="uk-visible" >

                <div >
                    <div class="uk-padding" >
                        <div class="uk-container uk-container-small">
                            <h1 class="uk-heading-line uk-text-center">
                                <span>Public Sector</span>
                            </h1>

                            <h3 class="uk-heading-bullet h2Style">Fully Outsourced or Temporary Financial Management</h3>
                            <p>
                                Fincor provides financial management services at strategic and
                                transactional levels to agencies with revenue ranging from $1 million
                                per annum to over $100 million. We lead the accounting journey from
                                financial data entry and reconciliations, all the way through to the
                                annual report preparation and audit. Our firm can also
                                provide strategic support and advice in the Board room, and or in
                                presentations to Cabinet.
                                We have been engaged to assist agencies in developing systems and controls to enhance
                                management’s framework; and assume full control of the accounting
                                and financial management functions of the organization.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="uk-padding uk-background-muted">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet  h2Style">
                            Preparation of Government Annual Reports
                        </h3>
                        <ul class="uk-list uk-list-bullet">
                            FINCOR is the provider of choice for over 10 Government Agencies
                            for professional services to highlight their strategic achievements and
                            financial performance for the year through Annual Reports. In working
                            with our clients we:
                            <li>Prepare messages from Chief Officers, Ministers, Board Chairs etc.;</li>
                            <li>Prepare the Management Discussion and Analysis;</li>
                            <li>Design Custom covers and artwork;</li>
                            <li>Provide commentary on financial performance and variance analysis;</li>
                            <li>Present statistics on staff demographics, agency output performance, financial performance and regulatory compliance;</li>
                            <li>Meet with Senior Managers and key staff to develop positive stories for the year’s performance</li>
                            <!--<li>Present a timely, professional and complete document
                                for presentation to Audit, Cabinet, and the Legislative
                                Assembly.</li>-->
                        </ul>
                    </div>
                </div>
                <div class="uk-padding">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet h2Style">Cost and Performance Management</h3>
                        <p>
                            Running a public sector entity can be a tough job. As the Chief Officer
                            or CEO for smaller agencies, it is not uncommon for you to also be the
                            head of marketing, human resources, information technology,
                            business development, and also the Chief Accountant. When Chief
                            Officers and CEOs find themselves stretched this thin, one of the first
                            areas that they start falling behind on is the record keeping. This can
                            be a huge and fatal mistake.
                        </p>
                        <p>
                            As a public sector leader, your primary job is to make decisions.
                            Making decisions in a vacuum, without the critical financial information
                            about what is happening in your agency, is likely to result in costly
                            mistakes, public criticism and wastage.
                        </p>
                        <p>
                            You've probably heard the saying, ‘you can't manage what you don't
                            measure,’ and it's true. If you are failing to capture key information,
                            how would you gauge the effectiveness of your agency’s service
                            delivery model? How do you know if you are appropriately recovering
                            the cost for services provided? How is your agency doing compared to
                            key benchmarks? How effectively are you collecting your receivables?
                            Are you really delivering on your mandate?
                        </p>
                        <p>
                            FINCOR provides services to public sector leaders to help them
                            positively answer many of these questions. We have over 10 years’
                            experience working in the public sector in senior leadership roles
                            looking at various aspects of cost and performance management. We
                            fully understand the challenges and complexities of budget cuts,
                            stringent deadlines, and increasing pressures for service delivery. We
                            can help you get through it.
                        </p>
                    </div>
                </div>
                <div class="uk-padding uk-background-muted">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet h2Style">Business Case Preparation</h3>
                        <p>
                            Under the Public Management and Finance Act, Public Sector
                            Agencies are required to ensure that projects are suitably appraised,
                            and that a robust cost benefit analysis has been carried out, before the
                            procurement stage to ensure value for money. A key instrument in
                            complying with this requirement is the preparation of a Business Case.
                            The main purpose of the Business Case is to establish the need for
                            the investment; appraise the main options for service delivery; and
                            assess the areas of affordability and the organization’s ability to
                            implement.
                            <br>
                            FINCOR works with Public Agencies to develop business cases as
                            strategic management tools, and comply with legal requirements.
                        </p>
                    </div>
                </div>
                <div class="">
                    <div class="uk-padding" style="background: rgba(197, 179, 88, 0.2)">
                        <div class="uk-container uk-container-small">
                            <div class="uk-child-width-1-2@m" uk-grid>
                                <div>
                                    <h3 class="uk-heading-bullet h2Style">Development of Policies & Procedures</h3>
                                    <p>
                                        FINCOR has vast experience in the development of policies and
                                        procedures to guide procurement and overall financial management.

                                    </p>
                                </div>
                                <!--<div>
                                    <h3 class="uk-heading-bullet h2Style">Outsourced Internal Audit</h3>
                                    <p>
                                        Our Internal Audit service allows for the full execution of a risk-focused
                                        internal audit plan delivered by our professional staff. We provide a
                                        designated financial professional who reports directly to the Audit
                                        Committee or the Board of Directors.
                                        This reduces the difficulty and cost of recruiting, compensating,
                                        training and managing full-time internal audit staff.
                                    </p>
                                </div>-->
                                <div>
                                    <h3 class="uk-heading-bullet h2Style">Outsourced compliance services</h3>
                                    <p>
                                        Public agencies must comply with a range of policies and procedures
                                        prescribed statutorily, through accounting standards and by
                                        Commissions and Boards. FINCOR can assist with the development
                                        and monitoring of a compliance framework to give management added
                                        assurance that policies and procedures are adhered while they focus
                                        on running the overall organization.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!--<div class="uk-padding ">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet h2Style">Implementation of Audit Recommendations</h3>
                        <ul class="uk-list uk-list-bullet">
                            The audit offices (internal and external) play a key role in reviewing
                            internal controls and making recommendations for improvement. Part
                            of their role is to review systems and processes, identify deficiencies,
                            and make recommendations for reducing risk, enhancing value for
                            money and improving efficiency.
                            Once management accepts the recommendations, they are frequently
                            given a defined period to implement changes and act on those
                            recommendations. FINCOR can assist your agency with an internal
                            audit or ISA 260 report by taking ownership for driving the accepted
                            recommended changes. That means, we will:
                            <li>Meet with the key stakeholders</li>
                            <li>Develop an action plan</li>
                            <li>Agree the action plan with management</li>
                            <li>Provide support with the implementation of the plan; and</li>
                            <li>Provide progress reports to Senior Management as the
                                implementation moves forward</li>
                        </ul>
                    </div>
                </div>-->
                <div class="uk-padding ">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet h2Style">Management of Strategic Initiatives</h3>
                        <p>
                            Let FINCOR assist you in the execution of your next strategic or policy
                            objective. As a strategic partner, we will assist in the development,
                            facilitation, and management of your organization’s various strategic
                            initiatives, corporate priorities, and other policy objectives. This
                            includes project planning, human and financial resource management,
                            and soliciting external support. FINCOR will assist in
                            intergovernmental issues, often involving high-profile, complex, and
                            strategic objectives, by providing in-depth, high-quality strategic
                            analyses. We will also recommend alternative strategies to enhance
                            policy effectiveness across the organization, guide future priorities,
                            and provide direction in support of the organization’s overall strategic
                            goals.
                        </p>
                    </div>
                </div>
            </div>


        </div>
    </transition>
</template>

<script>
    export default {
        name: "publicSector",
      metaInfo: {
        title: ' Public Sector Services',
        meta: [{
          content: 'FINCOR provides several services in the public sector such as: Outsourced/Temporary Financial Management, Preparation of Government Annual Reports, Business Case Preparation, Development of Policies & Procedures, Outsourced Compliance Services and Management of Strategic Initiatives.'
        }]
      }
    }
</script>

<style scoped>
    .testStep{
        background-image: url('~@/assets/page_bg.png');
        background-size: cover;
    }
    .h2Style{
        font-family: 'Overlock SC';
    }
</style>